// extracted by mini-css-extract-plugin
export default {"Highlight":"Highlight_Highlight__iJ9KX"};